import { render } from "./FrenKaliperi.vue?vue&type=template&id=861ba0fa"
import script from "./FrenKaliperi.vue?vue&type=script&lang=js"
export * from "./FrenKaliperi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__